export const igamUrl: String = "https://us.grantrequest.com"